export const PROMOTION__CRITERIA = Object.freeze({
  MTD_Orders_Value: "MTD_Orders_Value",
  MTD_Number_Of_Orders: "MTD_Number_Of_Orders",
});
